import orderTranslationsHelper from "../../../../../../../languages/order-translations.helper";
import { OrderDetailsHistoryEntryShuffleMergeEvent } from "../../../common/types/order-details-history-entry-event";

const getSourceOrdersLabel = (
  sourceInternalOrderIds: OrderDetailsHistoryEntryShuffleMergeEvent["sourceInternalOrderIds"],
) => {
  const translations =
    orderTranslationsHelper.getDetailsHistoryTranslations().shuffleMergeEntry
      .sourceOrderTemplateText;

  return translations.replace(
    "#{orderInternalIds}",
    sourceInternalOrderIds.join(", "),
  );
};

const getTargetOrderLabel = (
  targetInternalOrderId: OrderDetailsHistoryEntryShuffleMergeEvent["targetInternalOrderId"],
) => {
  const translations =
    orderTranslationsHelper.getDetailsHistoryTranslations().shuffleMergeEntry
      .targetOrderTemplateText;

  return translations.replace("#{orderInternalId}", targetInternalOrderId);
};

const orderDetailsHistoryEntryShuffleMergeContentHelper = {
  getSourceOrdersLabel,
  getTargetOrderLabel,
};

export default orderDetailsHistoryEntryShuffleMergeContentHelper;
